import type * as React from "react"
import type { ReactElement } from "react"
import type { i18n, Namespace, ParseKeys, TFunction, TOptions } from "i18next"
import type { _DefaultNamespace, TransChild } from "react-i18next/TransWithoutContext"

import { Trans as TransWithoutContext } from "react-i18next/TransWithoutContext"

// From official i18next type definition - Made t, i18n, i18nkey required - i18n has to be there for translation on client components for some reason
type TransProps<
  Key extends ParseKeys<Ns, TOpt, KPrefix>,
  Ns extends Namespace = _DefaultNamespace,
  TOpt extends TOptions = {},
  KPrefix = undefined,
  E = React.HTMLProps<HTMLDivElement>,
> = E & {
  children?: TransChild | readonly TransChild[]
  components?: readonly React.ReactElement[] | Readonly<Record<string, React.ReactElement>>
  count?: number
  context?: string
  defaults?: string
  i18n: i18n
  i18nKey: Key | Key[]
  ns?: Ns
  parent?: string | React.ComponentType<any> | null // used in React.createElement if not null
  tOptions?: TOpt
  values?: {}
  shouldUnescape?: boolean
  t: TFunction<Ns, KPrefix>
}

export type TransComponent = <
  Key extends ParseKeys<Ns, TOpt, KPrefix>,
  Ns extends Namespace = _DefaultNamespace,
  TOpt extends TOptions = {},
  KPrefix = undefined,
  E = React.HTMLProps<HTMLDivElement>,
>(
  props: TransProps<Key, Ns, TOpt, KPrefix, E>,
) => ReactElement

// Wrapper for Trans without context since it is not displayed in import possibilities else
// @ts-ignore
export const Trans: TransComponent = TransWithoutContext
